import firebase from "../Config/Firebase"

export async function getAllProjects(){
    const querySnapshot = await firebase.db.collection("Projects")
    .get()
    return querySnapshot.docs
}
export async function getByIdProductos(id){
    const querySnapshot = await firebase.db.doc("Projects/"+id).get()
    return querySnapshot
}

export async function getAllStudies(){
    const querySnapshot = await firebase.db.collection("Studies")
    .get()
    return querySnapshot.docs
}